import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getDashboardData } from '../slice/contactUsSlice';
import CountUp from 'react-countup';
import { FaUserTie, FaRegBuilding, FaUserCheck, FaUsers, FaMoneyCheckAlt, FaChartLine, FaImage } from "react-icons/fa";

function Home() {
  const dispatch = useDispatch();
  const Data = useSelector((state) => state.contactus);
  const { table_counts } = Data?.data || {};

  useEffect(() => {
    dispatch(getDashboardData());
  }, [dispatch]);

  // Card Data Array to easily map them
  const cards = [
    {
      title: "Total Categories",
      count: table_counts?.category || 0,
      icon: <FaRegBuilding />,
      gradient: "linear-gradient(135deg, #0EA5A4 0%, #082032 100%)",
      shadow: "rgba(14, 165, 164, 0.4)",
      subtitle: "Active Categories"
    },
    {
      title: "Loan Providers",
      count: table_counts?.servicemen || table_counts?.loanprovider || 0,
      icon: <FaUserTie />,
      gradient: "linear-gradient(135deg, #48cae4 0%, #0b4f6c 100%)",
      shadow: "rgba(72, 202, 228, 0.4)",
      subtitle: "Registered Providers"
    },
    {
      title: "Investors",
      count: table_counts?.investor || 0,
      icon: <FaUserCheck />,
      gradient: "linear-gradient(135deg, #10B981 0%, #065F46 100%)",
      shadow: "rgba(16, 185, 129, 0.4)",
      subtitle: "Active Investors"
    },
    {
      title: "Total Users",
      count: table_counts?.customer || 0,
      icon: <FaUsers />,
      gradient: "linear-gradient(135deg, #F59E0B 0%, #92400E 100%)",
      shadow: "rgba(245, 158, 11, 0.4)",
      subtitle: "Registered Borrowers"
    },
    {
      title: "Total Loans",
      count: table_counts?.ordercount || table_counts?.loan || 0,
      icon: <FaMoneyCheckAlt />,
      gradient: "linear-gradient(135deg, #8B5CF6 0%, #4C1D95 100%)",
      shadow: "rgba(139, 92, 246, 0.4)",
      subtitle: "Loans Processed"
    },
    {
      title: "Active Banners",
      count: table_counts?.banner || 0,
      icon: <FaImage />,
      gradient: "linear-gradient(135deg, #EC4899 0%, #9D174D 100%)",
      shadow: "rgba(236, 72, 153, 0.4)",
      subtitle: "Running Promotions"
    }
  ];

  return (
    <>
      {/* Light Background Theme Container */}
      <div style={{
        minHeight: '85vh',
        background: 'linear-gradient(135deg, #F0FDFA 0%, #E0F2FE 100%)',
        padding: '2rem 1rem',
      }}>

        <style dangerouslySetInnerHTML={{__html: `
          @keyframes slideUpFade {
            from { opacity: 0; transform: translateY(40px); }
            to { opacity: 1; transform: translateY(0); }
          }
          .premium-stat-card {
            border-radius: 20px;
            padding: 1.5rem;
            position: relative;
            overflow: hidden;
            transition: all 0.3s ease;
            animation: slideUpFade 0.6s ease-out forwards;
            opacity: 0;
            color: white;
            border: none;
            z-index: 1;
          }
          .premium-stat-card:hover {
            transform: translateY(-8px);
          }
          .premium-stat-card::after {
            content: '';
            position: absolute;
            top: 0; left: 0; right: 0; bottom: 0;
            background: linear-gradient(rgba(255,255,255,0.1), rgba(255,255,255,0));
            z-index: -1;
          }
          .icon-bg {
            position: absolute;
            right: -20px;
            bottom: -20px;
            font-size: 120px;
            opacity: 0.15;
            z-index: -1;
            transform: rotate(-15deg);
            transition: all 0.3s ease;
          }
          .premium-stat-card:hover .icon-bg {
            transform: rotate(0deg) scale(1.1);
            opacity: 0.25;
          }
          .header-text {
            color: #082032;
            font-weight: 800;
            letter-spacing: -0.5px;
          }
          .header-accent {
            color: #0EA5A4;
          }
        `}} />

        {/* Header Section */}
        <div className="d-sm-flex align-items-center justify-content-between mb-4">
          <div>
            <h1 className="h3 mb-1 header-text">
              Dashboard <span className="header-accent">Overview</span>
            </h1>
            <p className="text-muted mb-0">System metrics and entity counts</p>
          </div>
        </div>

        {/* Premium Cards Grid */}
        <div className="row">
          {cards.map((card, index) => (
            <div className="col-xl-4 col-lg-6 col-md-6 mb-4" key={index}>
              <div 
                className="premium-stat-card shadow-lg" 
                style={{ 
                  background: card.gradient, 
                  animationDelay: `${0.1 * index}s`,
                  boxShadow: `0 10px 20px ${card.shadow}`
                }}
              >
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="text-uppercase font-weight-bold" style={{ fontSize: '13px', letterSpacing: '1px', opacity: 0.9 }}>
                    {card.title}
                  </div>
                  <div style={{ fontSize: '24px', opacity: 0.9 }}>
                    {card.icon}
                  </div>
                </div>
                
                <h2 className="display-4 font-weight-bold mb-0">
                  <CountUp end={card.count} duration={2.5} separator="," />
                </h2>
                
                <div className="mt-3 pt-3" style={{ borderTop: '1px solid rgba(255,255,255,0.2)' }}>
                  <span style={{ fontSize: '14px', opacity: 0.8 }}>
                    <FaChartLine className="mr-2" />
                    {card.subtitle}
                  </span>
                </div>

                <div className="icon-bg">
                  {card.icon}
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </>
  );
}

export default Home;
